import { Component, Input, OnChanges} from '@angular/core';
import { EsriLoadService, LoadedModules } from '../shared/esri-load-control.service';
import { Util } from '../shared/util.service';


@Component({
  standalone: false,
  selector: 'app-map-saneamento-clie',
  templateUrl: './map-saneamento-clie.component.html',
  styleUrls: ['./map-saneamento-clie.component.css']
})
export class MapSaneamentoClieComponent implements OnChanges {


  @Input() latAntiga = 0;
  @Input() longAntiga = 0;
  @Input() dadosSaneamento?: any = null;
  
  latNova = 0;
  longNova =  0;
  distanciaDiff = 0
  public map: any;
  public view: any;
  constructor(    private esriLoadService: EsriLoadService,) { }

  ngOnChanges(): void {

    let json = JSON.parse(this.dadosSaneamento)
    this.latNova = json.latitude
    this.longNova = json.longitude

    const centerLat = (this.latAntiga + this.latNova) / 2;
    const centerLong = (this.longAntiga + this.longNova) / 2;

    this.distanciaDiff = Util.calcularDistanciaGeo(this.latAntiga, this.longAntiga,this.latNova, this.longNova)

    this.esriLoadService.loadClass()
    .then(() => {
   
      this.map = new LoadedModules.Map(
        {
          basemap: 'streets-vector',          
        }
      );

      this.view = new LoadedModules.MapView({
        container: "map",
        center: [centerLong ,centerLat],
        zoom: 11,
        map: this.map,
        popup: {
          dockEnabled: false,
          dockOptions: {
            buttonEnabled: false,
            breakpoint: false
          },
          visibleElements: {
            closeButton: false
          },
        },
      });

      
      //Cria linha no mapa
      const polyline = new LoadedModules.Polyline({
        paths: [
          [this.longAntiga, this.latAntiga], 
          [this.longNova, this.latNova] 
        ]
      });
      const lineSymbol = {
        type: "simple-line",
        color: [0, 0, 0, 1], 
        width: 2, 
        style: "dash" 
      };
      const graphicLine = new LoadedModules.Graphic({
        geometry: polyline,
        symbol: lineSymbol
      });
      this.view.graphics.add(graphicLine);


      //criar ponto antigo
      const svgIconAntigo = `<svg width="20" height="26" viewBox="0 0 20 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 25.5C10 25.5 20 17.2598 20 10.25C20 4.86522 15.5228 0.5 10 0.5C4.47715 0.5 0 4.86522 0 10.25C0 17.2598 10 25.5 10 25.5Z" fill="#FB8C00"/>
      <path d="M17 10.5C17 14.366 13.866 17.5 10 17.5C6.13401 17.5 3 14.366 3 10.5C3 6.63401 6.13401 3.5 10 3.5C13.866 3.5 17 6.63401 17 10.5ZM10 7C9.53152 7 9.16545 7.4045 9.21207 7.87066L9.51897 10.9397C9.54368 11.1868 9.75164 11.375 10 11.375C10.2484 11.375 10.4563 11.1868 10.481 10.9397L10.7879 7.87066C10.8345 7.4045 10.4685 7 10 7ZM10.0013 12.25C9.5181 12.25 9.12635 12.6418 9.12635 13.125C9.12635 13.6082 9.5181 14 10.0013 14C10.4846 14 10.8763 13.6082 10.8763 13.125C10.8763 12.6418 10.4846 12.25 10.0013 12.25Z" fill="white"/>
      </svg>
      `;      
      const markerSymbolAntigo = {
      type: "picture-marker",
      url: "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svgIconAntigo),
      width: "20px",
      height: "26px"
      };

      const pointAntigo = new LoadedModules.Point({
      longitude: this.longAntiga,
      latitude: this.latAntiga
      });
   
      const graphicAntigo = new LoadedModules.Graphic({
      geometry: pointAntigo,
      symbol: markerSymbolAntigo
      });
      this.view.graphics.add(graphicAntigo);


      //criar ponto atual
      const svgIconAtual = `<svg width="20" height="26" viewBox="0 0 20 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 25.5C10 25.5 20 17.2598 20 10.25C20 4.86522 15.5228 0.5 10 0.5C4.47715 0.5 0 4.86522 0 10.25C0 17.2598 10 25.5 10 25.5Z" fill="#00B951"/>
      <path d="M17 10.5C17 14.366 13.866 17.5 10 17.5C6.13401 17.5 3 14.366 3 10.5C3 6.63401 6.13401 3.5 10 3.5C13.866 3.5 17 6.63401 17 10.5ZM13.5265 7.84846C13.2703 7.59218 12.8547 7.59218 12.5985 7.84846C12.5923 7.85465 12.5865 7.86121 12.581 7.86809L9.54272 11.7396L7.71089 9.90782C7.45461 9.65154 7.0391 9.65154 6.78281 9.90782C6.52653 10.1641 6.52653 10.5796 6.78281 10.8359L9.09846 13.1515C9.35474 13.4078 9.77025 13.4078 10.0265 13.1515C10.0322 13.1458 10.0376 13.1398 10.0427 13.1335L13.5358 8.76704C13.7828 8.51009 13.7797 8.1016 13.5265 7.84846Z" fill="white"/>
      </svg>
    `;      
      const markerSymbolAtual = {
      type: "picture-marker",
      url: "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svgIconAtual),
      width: "20px",
      height: "26px"
      };

      const pointAtual = new LoadedModules.Point({
      longitude: this.longNova,
      latitude: this.latNova
      });
    
      const graphicAtual = new LoadedModules.Graphic({
      geometry: pointAtual,
      symbol: markerSymbolAtual
      });
      this.view.graphics.add(graphicAtual);

    })
  }

  abreStreetViewPrincipal() {
    const url = `https://www.google.com/maps?q=&layer=c&cbll=${this.latNova},${this.longNova}`;
    window.open(url, '_blank');
  }
}
